import React, { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';
import Gig from './Gig';
import RankArrows from './RankArrows';
import { SavedGigsContext } from './SavedGigsContext';
import { Box } from 'grommet';
import flags from 'components/common/flopflip-flags'
import SaveView from './SaveView'

const SavedGigs = (props) => {

    const savedGigsContext = useContext(SavedGigsContext)

    const { gigs } = props
    let firstGig = null,
        lastGig = null

    if (gigs.length > 0) {
        firstGig = gigs[0]
        lastGig = gigs[gigs.length - 1]
    }

    return (
        <SaveView items={gigs.map((gig) => {
            console.log('Rendering', gig)
            return(
                <Box
                    className="saved-gig"
                    key={gig.id}
                    pad={{'bottom': '25px'}}
                >
                    <Gig
                        // key is on parent
                        gig={gig}
                    />
                    <RankArrows
                        // key is on parent
                        thisItem={gig}
                        rankUp={flags.rankGigsIncrementally ? savedGigsContext.rankUp : null}
                        rankDown={flags.rankGigsIncrementally ? savedGigsContext.rankDown : null}
                        rankTop={savedGigsContext.rankTop}
                        rankBottom={savedGigsContext.rankBottom}
                        isFirst={gig === firstGig}
                        isLast={gig === lastGig}
                    />
                </Box>
            )
        })} />
    )
}

export default SavedGigs

SavedGigs.propTypes = {}
